import {Injectable} from "@angular/core";
import {environment} from '../../environments/environment';
import {HttpClient} from "@angular/common/http";
import {Observable, of} from "rxjs";
import {
  CampaignGroupTree,
  CreateCampaignGroupPayloadModel,
  GetAllCampaignGroupPayloadModel,
  UpdateCampaignGroupPayloadModel
} from './campaign_groups_interfaces';






@Injectable({providedIn: 'root'})
export class CampaignGroupsService {

  url:string = `${environment['API_URL']}`

  constructor(private http: HttpClient,) {} //end constructor

  gets(endpoint: string, is_mocked: boolean = false): Observable<GetAllCampaignGroupPayloadModel[]> {

    if(is_mocked) {
      return of<GetAllCampaignGroupPayloadModel[]>(
        [
          {
            "campaign_group_id": "1",
            "name": "Mock Client",
            "campaign_type": "Mock Campaign Type",
            "campaign_group_parent_id": "afdadf"
          }
        ]
      )
    } //end if is_mocked

    let url: string = `${this.url}/${endpoint}`;
    return this.http.get<GetAllCampaignGroupPayloadModel[]>(url);

  } //end gets

  getsTree(endpoint: string): Observable<CampaignGroupTree[]> {



    let url: string = `${this.url}/${endpoint}`;
    return this.http.get<CampaignGroupTree[]>(url);

  } //end gets

  get(endpoint: string, is_mocked: boolean = false): Observable<GetAllCampaignGroupPayloadModel> {

    if(is_mocked) {
      return of<GetAllCampaignGroupPayloadModel[]>(

          {
            "campaign_group_id": "1",
            "name": "Mock Client",
            "campaign_type": "Mock Campaign Type",
            "campaign_group_parent_id": "afdadf"
          }

      )
    } //end if is_mocked

    let url: string = `${this.url}/${endpoint}`;
    return this.http.get<GetAllCampaignGroupPayloadModel>(url);

  } //end gets

  post(endpoint: string, data: CreateCampaignGroupPayloadModel){
    return this.http.post<any>(`${this.url}/${endpoint}`, data,{observe: 'response'});
  } //end post

  put(endpoint: string, data: UpdateCampaignGroupPayloadModel){
    return this.http.put(`${this.url}/${endpoint}`, data,{observe: 'response'});
  } //end put

  delete(endpoint: string){
    let url = `${this.url}/${endpoint}`;
    return this.http.delete(url);
  } //end login


} //end CampaignGroupsService
